<div class="row">
	<div class="col-1 col-md-5 mb-4">
		<div class="card">
			<div class="card-header d-flex justify-start items-center gap-2" [appCheckPermission]="[2000, 5098]" [permissionType]="permissionType.ALL">
				<h3>Listas de Precios</h3>
				<span 
				class="a-hover font-bold text-primary cursor-pointer" 
				(click)="showModalCreateList = true"
				tooltip="Agregar Lista">
					<i class="fa fa-plus"></i> Agregar Lista
				</span>
			</div>
			<div class="card-body">
				<app-price-list-group (priceListEvent)="setCurrentList($event)" [saving]="saving"/>
			</div>
		</div>
	</div>
	<div class="col-1 col-md-7 mb-4">
		<div class="card">
			<div class="card-header">
				<h3>Detalles de la Lista: 
					<span *ngIf="productPriceList!=null" class="font-medium"> "{{productPriceList.name}}"</span>
				</h3>
			</div>
			<div class="card-body">
				<app-price-list-products-group [productPriceList]="productPriceList"/>
			</div>
		</div>
	</div>
</div>

<app-modal-dialog 
*ngIf="showModalCreateList" 
[show]="showModalCreateList" 
[title]="'Agregar Lista de Precios'"
[showHeader]="true"
[size]="'md'"
(closed)="closeModal($event)"
>
	<div modal-body>
		<div class="input-group col mb-4">
			<input type="text" 
				placeholder="Nombre" 
				class="form-control"
				[(ngModel)]="nameList"
			>
		</div>
		<div class="input-group col justify-end text-left">
			<ng-container *ngIf="loadingCreate">
				<button class="btn btn-success" [disabled]="loadingCreate">
					<i class="fa fa-spinner"></i> Agregando
				</button>
			</ng-container>
			<ng-container *ngIf="!loadingCreate">
				<button class="btn btn-success" (click)="addList()">
					<i class="fa fa-floppy-disk"></i> Agregar
				</button>
			</ng-container>
			<!-- <app-loading-button [object]="buttonSave" [logo]="true" [colorLoading]="'white'" (clicked)="addList()">
            </app-loading-button> -->
		</div>
	</div>

</app-modal-dialog>